import Vue from 'vue';
import axios from 'axios'

// Vendor-columns endpoint. Bulk (MTO) has its own route; Tagged/Packages keep the default.
// Callers signal Bulk via category or item_category === 'bulk'.
function vendorColumnsBase(params) {
    const cat = params && (params.category || params.item_category);
    return cat === 'bulk' ? '/bulk/offer/vendorcolumns' : '/offer/vendorcolumns';
}

const state = {
    groupData: {},
    tagsList: [],
    selectedDeviations: [],
    deviations: [],
    bidCurrency: { epc_currency: '$', vendor_currency: '$' },
    newBidTab: false
}

const mutations = {
    SET_GROUP_DATA(state, data) {
        Vue.set(state, 'groupData', data);
    },
    SET_TAGS_LIST(state, data) {
        Vue.set(state, 'tagsList', data);
    },
    SET_SELECTED_DEVIATIONS(state, data) {
        Vue.set(state, 'selectedDeviations', data);
    },
    SET_DEVIATIONS(state, data) {
        console.log('SET_DEVIATIONS', data);    
        Vue.set(state, 'deviations', data);
    },
    ADD_SELECTED_DEVIATION(state, item) {
        if (!state.selectedDeviations.includes(item)) {
            state.selectedDeviations.push(item);
        }
    },
    // thread_id	
    REMOVE_SELECTED_DEVIATION(state, item) {
        state.selectedDeviations = state.selectedDeviations.filter(i => i.thread_id !== item.thread_id);
    },
    SET_BID_CURRENCY(state, data) {
        Vue.set(state, 'bidCurrency', data || { epc_currency: '$', vendor_currency: '$' });
    },
    SET_NEW_BID_TAB(state, value) {
        Vue.set(state, 'newBidTab', !!value);
    }
}
const actions = {
    async getTagList({ commit}, params) {
        commit('SET_LOADING', true);
        let tags = [];
        let offerId = Array.isArray(params.offerId) ? params.offerId[0] : params.offerId;
        if(params.pageType === 'vendor') {
            tags =  await axios.get(`${process.env.VUE_APP_API}/mr/taglist?offer_id=${params.offerId}&token=${params.token}&vendor_id=${params.vendor_id}`);
        } else if(params.pageType === 'LHS') {
            tags = await axios.get(`${process.env.VUE_APP_API}/mr/taglist?mr_id=${params.mrId}`);
        } else {
            tags = await axios.get(`${process.env.VUE_APP_API}/mr/taglist?offer_id=${offerId}`);
        }
        commit('SET_TAGS_LIST', tags.data.tags);
    },
    async getRequirementGroups({ commit, state}, params) {
        console.log('getRequirementGroups',params);
        
        let groups;
        if(params.pageType === 'lhs' || params.pageType === 'vendorCompare'){
            if(params.activeTab === 'mr_compliance') {
                groups = await axios.get(`${process.env.VUE_APP_API}/compliance/groups?mr_id=${params.mrId}&category=${params.category}`);
            } else if(params.activeTab === 'scope_of_work') {
                groups = await axios.get(`${process.env.VUE_APP_API}/sow/groups?mr_id=${params.mrId}&category=${params.category}`);
            } else if(params.activeTab === 'commercial_evaluation') {
                groups = await axios.get(`${process.env.VUE_APP_API_CBE}/cbe/groups?mr_id=${params.mrId}&category=${params.category}`);
            }
        }else if(params.pageType === 'rhs'){
            if(params.activeTab === 'mr_compliance') {
                groups = await axios.get(`${process.env.VUE_APP_API}/compliance/groups?offer_id=${params.offerId}&category=${params.category}`);
            } else if(params.activeTab === 'scope_of_work') {
                groups = await axios.get(`${process.env.VUE_APP_API}/sow/groups?offer_id=${params.offerId}&category=${params.category}`);
            } else if(params.activeTab === 'commercial_evaluation') {
                groups = await axios.get(`${process.env.VUE_APP_API_CBE}/cbe/groups?offer_id=${params.offerId}&category=${params.category}`);
            }
        } else if(params.pageType === 'vendor'){
            if(params.activeTab === 'mr_compliance') {
                groups = await axios.get(`${process.env.VUE_APP_API}/compliance/groups?offer_id=${params.offerId}&vendor_id=${params.vendorId}&token=${params.token}&category=${params.category}`);
            } else if(params.activeTab === 'scope_of_work') {
                groups = await axios.get(`${process.env.VUE_APP_API}/sow/groups?offer_id=${params.offerId}&vendor_id=${params.vendorId}&token=${params.token}&category=${params.category}`);
            } else if(params.activeTab === 'commercial_evaluation') {
                groups = await axios.get(`${process.env.VUE_APP_API_CBE}/cbe/groups?offer_id=${params.offerId}&vendor_id=${params.vendorId}&token=${params.token}&category=${params.category}`);
            }
        }
        console.log('groups', groups);
        let groupData = {}
        groups.data.requirement_groups.forEach(group => {
            groupData[group] = {
                groupName: group,
                status: false,
                groupType: 'Technical',
            }
        });
        if(groups.data?.commercial_requirement_groups?.length){
            groups.data.commercial_requirement_groups.forEach(group => {
                groupData[group] = {
                    groupName: group,
                    status: false,
                    groupType: 'Commercial',
                }
            });
        }
        commit('SET_GROUP_DATA', groupData);
        // F2: default (EPC) currency now comes from the sow/groups API (epc_currency, top-level).
        // Preserve any existing vendor_currency in the store.
        if (groups?.data?.epc_currency) {
            const cur = state.bidCurrency || {};
            commit('SET_BID_CURRENCY', { ...cur, epc_currency: groups.data.epc_currency });
        } else if (groups?.data?.currency) {
            commit('SET_BID_CURRENCY', groups.data.currency);
        }
        commit('SET_NEW_BID_TAB', !!groups?.data?.new_bid_tab);
        return groups;
    },
    async getTechnicalSpec({ commit, state}, params) {
        let techSpec;
        if(params.pageType === 'lhs'){
            if(params.activeTab === 'mr_compliance') {
                techSpec = await axios.get(`${process.env.VUE_APP_API}/compliance/specification?mr_id=${params.mrId}&requirements_group=${params.group}&category=${params.category}`);
            } else if(params.activeTab === 'scope_of_work') {
                techSpec = await axios.get(`${process.env.VUE_APP_API}/sow/specification?mr_id=${params.mrId}&requirements_group=${params.group}&category=${params.category}&section=${params.section}`);
            } else if(params.activeTab === 'commercial_evaluation') {
                techSpec = await axios.get(`${process.env.VUE_APP_API_CBE}/cbe/specification?mr_id=${params.mrId}&requirements_group=${params.group}&category=${params.category}`);
            }
        }else if(params.pageType === 'rhs'){
            if(params.activeTab === 'mr_compliance') {
                techSpec = await axios.get(`${process.env.VUE_APP_API}/compliance/specification?offer_id=${params.offerId}&requirements_group=${params.group}&category=${params.category}`);
            } else if(params.activeTab === 'scope_of_work') {
                techSpec = await axios.get(`${process.env.VUE_APP_API}/sow/specification?offer_id=${params.offerId}&requirements_group=${params.group}&category=${params.category}&section=${params.section}`);
            } else if(params.activeTab === 'commercial_evaluation') {
                techSpec = await axios.get(`${process.env.VUE_APP_API_CBE}/cbe/specification?offer_id=${params.offerId}&requirements_group=${params.group}&category=${params.category}`);
            }
        }else if(params.pageType === 'vendor'){
            if(params.activeTab === 'mr_compliance') {
                techSpec = await axios.get(`${process.env.VUE_APP_API}/compliance/specification?offer_id=${params.offerId}&requirements_group=${params.group}&vendor_id=${params.vendorId}&token=${params.token}&category=${params.category}`);
            } else if(params.activeTab === 'scope_of_work') {
                techSpec = await axios.get(`${process.env.VUE_APP_API}/sow/specification?offer_id=${params.offerId}&requirements_group=${params.group}&vendor_id=${params.vendorId}&token=${params.token}&category=${params.category}&section=${params.section}`);
            } else if(params.activeTab === 'commercial_evaluation') {
                techSpec = await axios.get(`${process.env.VUE_APP_API_CBE}/cbe/specification?offer_id=${params.offerId}&requirements_group=${params.group}&vendor_id=${params.vendorId}&token=${params.token}&category=${params.category}`);
            }
        }else if(params.pageType === 'vendorCompare'){
            const data = {
                mr_id: params.mrId,
                requirement_group: decodeURIComponent(params.group),
                offer_id_list: params.offerId.split(','),
                category: params.category,
                section: params.section
            };
            if(params.activeTab === 'mr_compliance') {
                techSpec = await axios.post(`${process.env.VUE_APP_API_MSC}/compliance/comparison`, data);
            } else if(params.activeTab === 'scope_of_work') {
                techSpec = await axios.post(`${process.env.VUE_APP_API_MSC}/sow/comparison`, data);
            } else if(params.activeTab === 'commercial_evaluation') {
                techSpec = await axios.post(`${process.env.VUE_APP_API_CBE}/cbe/comparison`, data);
            }
        }
        let groups = JSON.parse(JSON.stringify(state.groupData))
        if(Array.isArray(techSpec.data.specification_data)) {
            // F2 (new_bid_tab ONLY): BE now returns qty / unit_price / total_price as objects
            // { name, data_type, value, uuid }. Flatten to the scalar fields the SOS grid binds to
            // (td.qty / td.price / td.total_price) and stash the cell objects under td.cell_meta so the
            // save path can target each cell by uuid. Old bids (new_bid_tab=false) are left exactly as-is.
            if (state.newBidTab) {
                techSpec.data.specification_data = techSpec.data.specification_data.map((row) => {
                    if (!row || typeof row !== 'object') return row;
                    const meta = {};
                    const flatten = (srcKey, targetKey) => {
                        if (!Object.prototype.hasOwnProperty.call(row, srcKey)) return;
                        const cell = row[srcKey];
                        if (cell && typeof cell === 'object') {
                            if ('value' in cell) {
                                meta[targetKey] = cell;        // keep { name, data_type, value, uuid } for save
                                row[targetKey] = cell.value;    // grid binds to the scalar
                            }
                            return;                             // {} = unfilled cell: leave the target alone
                        }
                        // Scalar form. A role-masked response sends the value as a bare string
                        // ("****"), not a { name, value } cell, so the object branch above never
                        // fires. That only broke ONE column: unit_price is the single field that is
                        // RENAMED (unit_price -> price), while every other field flattens onto its
                        // own name and so already held the right value by coincidence. Without this
                        // branch td.price kept the legacy `price` ("-----") and Unit Price rendered
                        // blank for Engineering while Total Price masked correctly.
                        row[targetKey] = cell;
                    };
                    flatten('qty', 'qty');
                    flatten('unit_price', 'price');             // BE renamed price -> unit_price; FE keeps td.price
                    flatten('total_price', 'total_price');
                    // SG2: BAFO / system fields are also returned as { name, value } objects — flatten them
                    // to the scalar fields the grid binds to.
                    flatten('bafo_unit_price', 'bafo_unit_price');
                    flatten('bafo_total_price', 'bafo_total_price');
                    flatten('bafo_discount_percent', 'bafo_discount_percent');
                    flatten('bafo_discount_amount', 'bafo_discount_amount');
                    flatten('bafo_tax_type', 'bafo_tax_type');
                    flatten('bafo_tax_rate', 'bafo_tax_rate');
                    flatten('bafo_comment', 'bafo_comment');
                    // F2 Obs#7: normalize independent Alternate Offer (BE returns "yes"/"no")
                    // to the radio's Yes/No. Preserve the unanswered state ('') so EPC can show
                    // "-----" until the vendor explicitly chooses (same as Vendor Response).
                    const _ao = String(row.alternate_offer).toLowerCase();
                    row.alternate_offer = _ao === 'yes' ? 'Yes' : (_ao === 'no' ? 'No' : '');
                    row.alternate_offer_remarks = row.alternate_model_spec || '';
                    if (Object.keys(meta).length) row.cell_meta = meta;
                    return row;
                });
            }
            Object.keys(groups).forEach(groupName => {
                if(encodeURIComponent(groupName) === params.group) {
                    console.log('techSpec', techSpec);
                    if(params.groupStatus) {
                        techSpec?.data?.specification_data?.forEach((val) => {
                            val['status'] = true;
                        })
                    }
                    groups[groupName] = {
                        groupName,
                        groupType: params.section,
                        status: params.groupStatus,
                        techSpec: techSpec.data.specification_data
                    }
                }
            });
        }
        commit('SET_GROUP_DATA', groups);
        // F2: default (EPC) currency is no longer sourced from the spec API — it now comes from
        // the sow/groups API (see getRequirementGroups). Only vendor_currency may still arrive
        // via spec additional_data; epc_currency from the spec response is intentionally ignored.
        if (state.newBidTab && techSpec?.data?.additional_data?.vendor_currency) {
            const cur = state.bidCurrency || {};
            commit('SET_BID_CURRENCY', {
                ...cur,
                vendor_currency: techSpec.data.additional_data.vendor_currency,
            });
        }
    },
    setSelectedDeviations({ commit, state }, deviations) {
        if (!deviations || deviations.length === 0) {
            commit('SET_SELECTED_DEVIATIONS', []);
        } else {
            const existing = new Set(state.selectedDeviations || []);
            deviations.forEach(id => existing.add(id));
            const deviationList = new Set(deviations);
            commit('SET_SELECTED_DEVIATIONS', Array.from(deviationList));
        }
    },
    addTechSpec({ commit}, params) {
        if(params.active_tab === 'mr_compliance') {
            return axios.post(`${process.env.VUE_APP_API}/compliance/specification`, params);
        } else if(params.active_tab === 'scope_of_work') { 
            return axios.post(`${process.env.VUE_APP_API}/sow/specification`, params);
        } else if(params.active_tab === 'commercial_evaluation') { 
            return axios.post(`${process.env.VUE_APP_API_CBE}/cbe/specification`, params);
        }
        
    },
    editTechSpec({ commit}, params) {
        if(params.active_tab === 'mr_compliance') {
            return axios.put(`${process.env.VUE_APP_API}/compliance/specification`, params);
        } else if(params.active_tab === 'scope_of_work') { 
            return axios.put(`${process.env.VUE_APP_API}/sow/specification`, params);
        } else if(params.active_tab === 'commercial_evaluation') { 
            return axios.put(`${process.env.VUE_APP_API_CBE}/cbe/specification`, params);
        }
    },
    updateStoreTechSpec({ commit, state}, params) {
        state.groupData[params.requirements_group].techSpec.find((item) => item.row_uuid === params.row_uuid)['2'] = params.new_value;
    },
    getTimeline({ commit}, params) {
        if(params.pageType === 'lhs') {
            return axios.get(`${process.env.VUE_APP_API_MSD}/quickaction?row_uuid=${params.row_uuid}&mr_id=${params.mrId}&category=${params.pageType}&active_tab=${params.activeTab}&item_category=${params.item_category}`)
        } else if(params.pageType === 'vendor') {
            return axios.get(`${process.env.VUE_APP_API_MSD}/quickaction?row_uuid=${params.row_uuid}&offer_id=${params.offerId}&category=${params.pageType}&active_tab=${params.activeTab}&vendor_id=${params.vendorId}&token=${params.token}&item_category=${params.item_category}`)
        }
        return axios.get(`${process.env.VUE_APP_API_MSD}/quickaction?row_uuid=${params.row_uuid}&offer_id=${params.offerId}&category=${params.pageType}&active_tab=${params.activeTab}&item_category=${params.item_category}`);
    },
    createIDC({ commit}, params) {
        console.log('createIDC', params);
        return axios.post(`${process.env.VUE_APP_API_MSD}/quickaction/bulk`, params);
    },
    reOrderGroup({ commit}, params) {
        if(params.category === 'packages') {
            return axios.put(`${process.env.VUE_APP_API}/package/arrange/groups`, params);
        }else{
            return axios.put(`${process.env.VUE_APP_API}/template/save`, params);
        }
    },
    getVendorName({ commit}, params) {
        return axios.get(`${process.env.VUE_APP_API}/offer/vendor_check?vendor_name=${params.getVendorName}&check=vendor_name&item=${params.mrId}`);
    },
    getvendorEmail({ commit}, params) {
        return axios.get(`${process.env.VUE_APP_API}/tbe/vendor_emails?${params.id}&vendor_id=${params.vendor}`);
    },
    publishMR({ commit}, params) {
        return axios.post(`${process.env.VUE_APP_API}/tbe/publish`, params);
    },
    publishMROld({ commit}, params) {
        return axios.post(`${process.env.VUE_APP_API}/mr/publish`, params);
    },
    forwardInternally({ commit}, params) {
        return axios.post(`${process.env.VUE_APP_API}/tbe/forward`, params);
    },
    getForwardInternallTimeline({ commit}, params) {
        return axios.post(`${process.env.VUE_APP_API}/offer/vendor_forward_timeline`, params);
    },
    getRHSPublishTimeline({ commit}, params) {
        if(params.token){
            return axios.get(`${process.env.VUE_APP_API}/rhs/publish/timeline?offer_id=${params.offer_id}&token=${params.token}&vendor_id=${params.vendor_id}&category=${params.category}`);
        }else{
            return axios.get(`${process.env.VUE_APP_API}/rhs/publish/timeline?offer_id=${params.offer_id}&category=${params.category}`);
        }
    },
    downloadLHSFile({state},params){
        if(params.type === 'packages'){
            return axios.get(`${process.env.VUE_APP_API}/mr/download?package_id=${params.id}&type=packages`);
        }else{
            return axios.get(`${process.env.VUE_APP_API}/mr/download?mr_id=${params.id}`);
        }
    },
    getOfferNames({state},params){
        if(params.pageType === 'vendorCompare'){
            return axios.get(`${process.env.VUE_APP_API}/offer/names?${params.id}`);
        }else{
            return axios.get(`${process.env.VUE_APP_API}/offer/names?id=${params.id}`);
        }
    },
    updateVendorResp({commit}, params) {
        if(params.active_tab === 'mr_compliance') {
            return axios.put(`${process.env.VUE_APP_API}/compliance/specification`, params);
        } else if(params.active_tab === 'scope_of_work') {
            return axios.put(`${process.env.VUE_APP_API}/sow/specification`, params);
        }
        return axios.put(`${process.env.VUE_APP_API_CBE}/cbe/specification`, params);
    },
    // SG2-US4: persist offer-level summary discount %. Backend endpoint TBD; using /sow/specification with offer-level flag for v1.
    saveSummaryDiscount({ commit }, params) {
        return axios.put(`${process.env.VUE_APP_API}/sow/specification`, { ...params, summary_discount_update: true });
    },
    // SG2: column-spec read API — single source of truth for the vendor's ADDED system fields
    // (system_defined_fields) and custom columns (custom_columns), plus caps/config.
    // Re-fetched on load and after every add/delete. params: { offer_id, vendor_id, token? }
    getColumnSpecifications({ commit }, params) {
        return axios.get(`${process.env.VUE_APP_BIDEVAL}/fetch/columnspecifications`, { params });
    },
    // SG3: persist the per-vendor column selection chosen in the download dialog (step 1).
    // Body: { column_details: [ { offer_id, vendor_name, vendor_id, columns: [{column_id, column_alias, column_name}] } ] }
    saveComparisonColumns({ commit }, params) {
        return axios.post(`${process.env.VUE_APP_API_MSC}/sow/comparison/columns`, params);
    },
    // SG2-US6: vendor adds a custom column. BE returns the saved column with stable id.
    addCustomColumn({ commit }, params) {
        return axios.post(`${process.env.VUE_APP_BIDEVAL}${vendorColumnsBase(params)}`, params);
    },
    // SG2-US6: vendor removes a custom column (pre-publish only). BE rejects with 400 after first publish.
    removeCustomColumn({ commit }, params) {
        return axios.delete(`${process.env.VUE_APP_BIDEVAL}${vendorColumnsBase(params)}/${params.id}`, { data: params });
    },
    // SG2-US2: bulk push OLD Unit Price → BAFO Unit Price for the whole offer.
    // Body: { vendor_id, token, offer_id, is_bulk_push: true }
    pushOldPrice({ commit }, params) {
        // Bulk (MTO) has its own push endpoint; Tagged/Packages keep /sow/push-old-price.
        const cat = params && (params.category || params.item_category);
        const path = cat === 'bulk' ? '/bulk/push-old-price' : '/sow/push-old-price';
        return axios.post(`${process.env.VUE_APP_BIDEVAL}${path}`, params);
    },
    // SG2: unified add/delete for system + custom columns. Same endpoint + body; the HTTP method
    // discriminates the action. Body: { offer_id, vendor_id, category, context, token, columns: [
    //   { type: 'system', key } | { type: 'custom', name, data_type } ] }
    addColumns({ commit }, params) {
        return axios.post(`${process.env.VUE_APP_BIDEVAL}${vendorColumnsBase(params)}`, params);
    },
    deleteColumns({ commit }, params) {
        return axios.delete(`${process.env.VUE_APP_BIDEVAL}${vendorColumnsBase(params)}`, { data: params });
    },
    saveInference({ commit}, params) {
        if(params.activeTab === 'mr_compliance'){
            return axios.post(`${process.env.VUE_APP_API_MSD}/compliance/inference`, params);
        }else{
            return axios.post(`${process.env.VUE_APP_API_MSD}/sow/inference`, params);
        }  
    },
    downloadTQ({ commit}, params) {
        return axios.get(`${process.env.VUE_APP_API_MSD}/tqthread/export?offer_id=${params.id}`);
    },
    async getDeviationList({ commit}, params) {        
        let deviations;
        if(params.pageType === 'vendor'){
            deviations = await axios.get(`${process.env.VUE_APP_API_MSD}/deviations?offer_id=${params.offerId}&token=${params.token}&vendor_id=${params.vendorId}&category=${params.category}&item_category=${params.item_category}`);
        }else{
            deviations = await axios.get(`${process.env.VUE_APP_API_MSD}/deviations?offer_id=${params.offerId}&category=${params.category}&item_category=${params.item_category}`);
        } 
        commit('SET_DEVIATIONS', deviations.data.deviations);
        return deviations;
    },
    updateDeviation({ commit}, params) {
        return axios.put(`${process.env.VUE_APP_API_MSD}/deviations`, params);
    },
    deleteDeviation({ commit}, params) {
        return axios.delete(`${process.env.VUE_APP_API_MSD}/deviations`, {data:params});
    },
    publishDeviation({ commit}, params) {
        return axios.post(`${process.env.VUE_APP_API_MSD}/deviations/publish`, params);
    },
    exportDeviations({ commit}, params) {
        return axios.get(`${process.env.VUE_APP_API_MSD}/deviations/export?token=${params.token}&vendor_id=${params.vendorId}&offer_id=${params.offerId}&category=${params.category}`);
    },
    collaborationStats({ commit}, params) {
        if(params.pageType === 'vendor'){
            return axios.post(`${process.env.VUE_APP_API}/vendor/offer/stats`, params);
        }else{
            return axios.post(`${process.env.VUE_APP_API_MSD}/collaboration/stats`, params);
        }
    },
    createDeviation({ commit}, params) {
        return axios.post(`${process.env.VUE_APP_API_MSD}/deviations`, params);
    },
    moveSpecs({ commit}, params) {
        return axios.put(`${process.env.VUE_APP_API}/arrange/lhs/tech-specs`, params);
    },
    extractDeviation({ commit}, params) {
        return axios.post(`${process.env.VUE_APP_API_MSD}/deviations/extract`, params);
    },
    downloadSampleFormat({ commit}, params) {
        return axios.get(`${process.env.VUE_APP_API}/template/formats/download?token=${params.token}&vendor_id=${params.vendorId}&format=${params.format}`);
    },
    getFileList({ commit}, params) {
        return axios.get(`${process.env.VUE_APP_API}/offer/names?id=${params.offerId}&token=${params.token}&vendor_id=${params.vendorId}`);
    },
    blankCheck({ commit}, params) {
        return axios.post(`${process.env.VUE_APP_API}/vendor/offer/stats`, params);
        // return axios.post(`${process.env.VUE_APP_API}/offer/blank/check`, params);
    },
    publishToClient({ commit}, params) {
        return axios.post(`${process.env.VUE_APP_API}/offer/publish`, params);
    },
    tbeActionsLHS({ commit}, params) {
        return axios.put(`${process.env.VUE_APP_API}/lhs/bulk_actions`, params);
    },
    tbeActionsRHS({ commit}, params) {
        return axios.post(`${process.env.VUE_APP_API_MSD}/rhs/bulk_actions`, params);
    },
    assinedListing({ commit}, params) {
        return axios.post(`${process.env.VUE_APP_API}/assignedlisting`, params);
    },
    publishDeviationResponse({ commit}, params){
        return axios.post(`${process.env.VUE_APP_API_MSD}/deviations/response/publish`, params);
    },
    addFollowup({ commit}, params) {
        return axios.post(`${process.env.VUE_APP_API_MSD}/deviations/followup`, params);
    },
    offerForward({ commit}, params) {
        return axios.post(`${process.env.VUE_APP_API}/offer/publish`, params);
    },
    downloadDeviationTemplate({ commit}, params) {
        return axios.get(`${process.env.VUE_APP_API}/template/formats/download?format=deviations&vendor_id=${params.vendor_id}&token=${params.token}`);
    },
    getFilterCountForDeviations({ commit}, params) {
        return axios.get(`${process.env.VUE_APP_API_MSD}/deviations/filters?offer_id=${params.offerId}${params.vendor_id?`&vendor_id=${params.vendor_id}&token=${params.token}`:''}`);
    }
}

const getters = {
    getGroupData() {
        return state.groupData;
    },
    getTagList(state) {
        return state.tagsList;
    },
    getSelectedDeviations(state) {
        return state.selectedDeviations.map(item => item.thread_id);
    },
    getSelectedDeviationThreads(state) {
        return state.selectedDeviations;
    },
    getDeviations(state) {
        console.log('getter triggered', state.deviations);
        return state.deviations;
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}